import * as actionTypes from './types';

export const buttonPending = () => {
    return {
        type: actionTypes.BUTTON_PENDING
    }
}

export const buttonSuccess = () => {
    return {
        type: actionTypes.BUTTON_SUCCESS
    }
}

